import { BaseModel } from './basemodel';

export interface ContentItemBase extends BaseModel {
  id: string;
  name: string;
  content?: string;
  type: ContentType;
  pageType?: PageType;
}

export interface ContentTreeItem extends ContentItemBase {
  children?: ContentTreeItem[];
}

export interface ContentAdminItem extends ContentItemBase {
  hidden: boolean;
  viewRoles: ContentViewRoles[];
  childrenCount?: number;
}

export interface ContentAdminTreeItem extends ContentAdminItem {
  children?: ContentAdminTreeItem[];
  visibility: ContentVisibility;
}

export enum ContentVisibility {
  FULL = 'FULL',
  PARTIAL = 'PARTIAL',
  NONE = 'NONE',
}

export enum ContentType {
  FOLDER = 'FOLDER',
  PAGE = 'PAGE',
}

export interface ContentItem extends ContentItemBase {
  parent?: ContentItem;
  children?: ContentItem[];
  viewRoles: ContentViewRoles[];
  inheritedViewRoles?: ContentViewRoles[];
}

export enum ContentViewRoles {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  PARTNER = 'PARTNER',
  CUSTOMER = 'CUSTOMER',
}

export enum PageType {
  WYSIWYG = 'WYSIWYG',
  HTML = 'HTML',
}
